// extracted by mini-css-extract-plugin
export default {"siteRoot":"PublicSiteLayout_siteRoot__qM8lQ","main":"PublicSiteLayout_main__sQvu4"};